export const converttonumber = num => +(parseFloat(num.toString().replace(/,/g, '')))